module.exports = __webpack_public_path__ + "img/camera_sidebar.4b6fb9ba.svg";